import React from 'react'
import Resx from '@/components/Resx'
import { localized } from '@/decorators/localized'
import { Main, MainTop, MainTopTitle, MainBody } from '@/components/Layout'
import { getStore } from '@/store'
import { ReportTable } from '@/components/report-tables'
import { headerTypes } from '@/components/report-tables/enums/headerTypes'
import { actionCreators as dialogActions } from '@/store/Dialogs'
import { dialogTypes } from '@/dialogs'

class TestComponent extends React.Component {
  render () {
    return <button className='btn-icon' onClick={() => getStore().dispatch(dialogActions.openDialog({
      dialogType: dialogTypes.confirm,
      title: 'Common.DeleteDialogTitle',
      content: 'Common.DeleteDialogText',
      onAction: () => () => {}
    }))}>H</button>
  }
}

@localized()
class TestPage extends React.Component {
  render () {
    return (
      <Main>
        <MainTop>
          <MainTopTitle>
            <Resx name='Common.Title' />
          </MainTopTitle>
        </MainTop>
        <MainBody>
          <ReportTable
            colHeaders
            rowHeaders
            stretchH='all'

            sourceHeaders={{ id: 1,
              name: 'root',
              order: 1,
              children: [
                {
                  id: 2,
                  name: 'jedna',
                  order: 1,
                  alias: 'I should get ignored',
                  renderer: { type: 'react', component: TestComponent },
                  children: [{
                    id: 3,
                    name: 'jedna A',
                    order: 1,
                    children: [
                      {
                        id: 4,
                        name: 'jedna A1',
                        order: 1,
                        children: [
                          { id: 5, name: 'A1A', order: 1, children: [] },
                          { id: 6, name: 'A1B', order: 2, children: [] }]
                      },
                      {
                        id: 7,
                        name: 'jedna A2',
                        order: 2,
                        children: [
                          { id: 8, name: 'jedna A2A', order: 1, children: [] },
                          {
                            id: 9,
                            name: 'jedna A2B',
                            order: 2,
                            children: [
                              { id: 10, name: 'dalsi', order: 1, children: [] },
                              { id: 11, name: 'a jeste jedna', order: 2, children: [] }]
                          }]
                      }]
                  }]
                },
                {
                  id: 12,
                  name: 'dve',
                  order: 2,
                  children: [{
                    id: 13,
                    name: 'dve A',
                    order: 1,
                    children: [
                      {
                        id: 14,
                        name: 'dve A1',
                        order: 1,
                        children: [
                          { id: 15, name: 'A1A', order: 1, children: [], alias: 'dude I am A1A' },
                          { id: 16, name: 'A1B', order: 2, children: [] }]
                      },
                      {
                        id: 17,
                        name: 'dve A2',
                        order: 2,
                        children: [
                          { id: 18, name: 'jedna A2A', order: 1, children: [] },
                          { id: 19, name: 'jedna A2B', order: 2, children: [] }]
                      }]
                  }]
                },
                { id: 20,
                  name: 'tri',
                  order: 3,
                  children: [
                    { id: 21, name: 'tri A', order: 1, children: [] }
                  ]
                }
              ] }}

            sourceRowHeaders={{ id: 1,
              name: 'helloWorld',
              order: 1,
              type: headerTypes.Root,
              children: [
                { id: 2, name: 'A', order: 1, type: headerTypes.Classic, children: [] },
                { id: 3,
                  name: 'B',
                  order: 2,
                  type: headerTypes.Classic,
                  children: [
                    { id: 4,
                      name: 'B1',
                      order: 1,
                      type: headerTypes.UnderAndAboveChildren,
                      children: [
                        { id: 5, name: 'B1A', order: 1, type: headerTypes.Classic, children: [] },
                        { id: 6, name: 'B1B', order: 2, type: headerTypes.Classic, children: [] },
                        { id: 7, name: 'B1C', order: 3, type: headerTypes.Classic, children: [] }
                      ] },
                    { id: 8,
                      name: 'B2',
                      order: 2,
                      type: headerTypes.UnderChildren,
                      children: [
                        { id: 9,
                          name: 'B2A',
                          order: 1,
                          type: headerTypes.Classic,
                          children: [
                            { id: 10, name: 'B2A1', order: 1, type: headerTypes.Classic, children: [] }
                          ] }
                      ] }
                  ] },
                { id: 11,
                  name: 'C',
                  order: 3,
                  type: headerTypes.Classic,
                  children: [
                    { id: 12, name: 'C1', order: 1, type: headerTypes.Classic, children: [] }
                  ] }
              ] }}

            sourceData={[
              { row: 0, cells: [ { col: 0, value: '53' }, { col: 1, value: '156' }, { col: 2, value: '546' }, { col: 5, value: '132' } ] },
              { row: 2, cells: [ { col: 2, value: '46' }, { col: 4, value: '235' } ] },
              { row: 10, cells: [ { col: 9, value: '666' } ] }
            ]}

            onCellsChange={(newCell) => console.log(newCell)}
            coordinateAliases={{ rows: { 0: 'I am row 0' }, cols: { 0: 'I am col 0' } }}
          />
        </MainBody>
      </Main>
    )
  }
}

export default TestPage



// WEBPACK FOOTER //
// ./src/internal-app/pages/TestPage.js